import React from "react";

function ModaBottomLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="348"
      height="9"
      viewBox="0 0 348 9"
      fill="none"
    >
      <path
        d="M0 8.5C165.965 -2.12976 182.58 -2.20351 348 8.5H0Z"
        fill="white"
      />
    </svg>
  );
}

export default ModaBottomLogo;
